/**
 * @description 触发数据源请求
 * @author henryguoheng
 */

export default function (eventData = {}) {
    const dataSourceName = eventData.dataSourceName
    if (!dataSourceName) {
        console.error('数据源未找到', dataSourceName)
        return
    }
    window.__XPUB__.fetchSource({ name: dataSourceName }).then(() => { console.log(`fetch ${dataSourceName} done`) })
}
